import React from "react";
import styles from "./styles.scss";

// TODO: Temp component, update to use when ds/core/Divider is created, no ticket yet.
export const Divider: React.FC = ({ children }) => {
  return (
    <div className={styles.Divider__container}>
      <div className={styles.Divider__border} />
      {children && <span className={styles.Divider__content}>{children}</span>}
      <div className={styles.Divider__border} />
    </div>
  );
};
